
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guided-motorcycle-tours",
      function () {
        return require("private-next-pages/guided-motorcycle-tours.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guided-motorcycle-tours"])
      });
    }
  